import { useEffect, useRef, useState } from 'react'
import { NAME_SUGGESTIONS_SERVICE } from '@/Constants'

interface NameSuggestionsInput {
  eventName?: string
  eventTypeName?: string
  capacity?: number
  layoutName?: string
  styleNames?: string[]
  cateringNeeds?: string
  additionalNotes?: string
}

interface NameSuggestionsOptions {
  // We want to delay the request until the event type name and styles names are set as they are sent on a different query
  pause?: boolean
}

export default function useEventNameSuggestions(
  input: NameSuggestionsInput,
  { pause = false }: NameSuggestionsOptions = {}
): {
  suggestions: string[]
  loading: boolean
} {
  const [suggestions, setSuggestions] = useState<string[]>([])
  const [loading, setLoading] = useState(!!NAME_SUGGESTIONS_SERVICE)
  const hasFetchedRef = useRef(false)

  useEffect(() => {
    if (!NAME_SUGGESTIONS_SERVICE || pause || hasFetchedRef.current) return
    hasFetchedRef.current = true

    const endpoint = NAME_SUGGESTIONS_SERVICE

    const run = async () => {
      try {
        const res = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(input),
        })
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        const { names } = (await res.json()) as { names: string[] }
        setSuggestions(names ?? [])
      } catch (err) {
        console.warn('[useEventNameSuggestions] Failed to load suggestions:', err)
      } finally {
        setLoading(false)
      }
    }

    run()
  }, [pause])

  return { suggestions, loading }
}
